import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';
import { usePlan } from '../../plan/hooks/plan';
import TranscriptLimitWarning from './TranscriptLimitWarning';

const TranscriptLimitReached: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { isPlan } = usePlan();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-screen text-center p-2">
      <MessageSquare className="w-11 h-11 text-muted-foreground" />
      <h2 className="text-2xl text-foreground mt-4">
        Ask AI Requires a Transcript
      </h2>
      <p className="text-base text-muted-foreground mt-2">
        You&apos;ve reached your transcript limit and can&apos;t use the
        &quot;Ask AI&quot; feature.{' '}
        {isPlan(['ENTERPRISE'])
          ? 'Please contact your administrator or support for assistance.'
          : 'Upgrade your plan to continue.'}
      </p>
      <Button variant="outline" onClick={handleClickOpen} className="mt-4">
        Learn More
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Why Can&apos;t I Use &quot;Ask AI&quot;?</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <p className="text-base">
              &quot;Ask AI&quot; uses transcripts to understand your audio or
              video content. Transcripts are text versions of what is spoken in
              your recordings.
            </p>
            <p className="text-base mt-4">
              You&apos;ve hit the limit of transcripts your plan allows.{' '}
              {isPlan(['ENTERPRISE'])
                ? 'Please contact your administrator or support for assistance.'
                : 'Upgrade to transcribe and keep using "Ask AI".'}
            </p>
            {!isPlan(['ENTERPRISE']) && (
              <div className="mt-4">
                <TranscriptLimitWarning position="bottom" />
              </div>
            )}
          </div>
          <DialogFooter>
            <Button onClick={handleClose} variant="outline">
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TranscriptLimitReached;
